import { render, staticRenderFns } from "./SuperiorMenu.vue?vue&type=template&id=4f3acc71"
import script from "./SuperiorMenu.vue?vue&type=script&lang=js"
export * from "./SuperiorMenu.vue?vue&type=script&lang=js"
import style0 from "./SuperiorMenu.vue?vue&type=style&index=0&id=4f3acc71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports